declare var jQuery:any;
declare var mincart_actions:any;

class MinCartActions {
    private min_cart_wrapper:any = '.min-cart-item-wrapper';

    constructor() {}

    public startCartEvents = () =>  {
        jQuery(this.min_cart_wrapper).on('create-cart-event', (e:any) => {
            this.startCartEvents();
        });
        
        jQuery( 'a.remove' ).off( 'click', (e:any) => {this.removeFromCartWUpdate(e) });
        jQuery( 'a.remove' ).on( 'click', (e:any) => {this.removeFromCartWUpdate(e) });
    }

    private removeFromCartWUpdate =(e:any) => {
        let button:any = jQuery(e.target);
        let prodId:string = button.data('product_id');
        let cart_item_key:string = button.data('cart_item_key');
        let removeCart:any = jQuery.post( mincart_actions.ajax_url, {action: "removeToCart", cart_item_key:  cart_item_key, nonce: mincart_actions.nonce_frontend} );
        removeCart.done(( data:any ) => {
            var done = false;
            if(!done){
                let updateCart:any = jQuery.post( mincart_actions.ajax_url, {action: "wc_refresh_min_cart"} );
                updateCart.done(( response:any ) => {
                    if (response.success) {
                        jQuery(this.min_cart_wrapper).empty();
                        jQuery(this.min_cart_wrapper).append(response.data.cart);
                        this.startCartEvents();
                    }
                    jQuery( "[name='refresh_cart']" ).trigger( "click" );
                    const customCartEvent = new Event('cart_refreshed');
                    jQuery(this.min_cart_wrapper).trigger('update-list', prodId);
                    window.dispatchEvent(customCartEvent);
                });
                done = true;
            }
            jQuery(this.min_cart_wrapper).trigger('update-list', prodId);
        });
    }
}

jQuery( document ).ready(function($:any) {
    let mainClass:MinCartActions = new MinCartActions();
    mainClass.startCartEvents();
});
